import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { handleRoleBasedRouting, getPrimaryRole } from '../utility/roleRoutingUtils';
import './AuthPage.css';

/**
 * Landing page that redirects based on authentication status
 */
const LandingPage = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated && user) {
        // Handle role-based routing using utility function
        const wasRedirected = handleRoleBasedRouting(user, history.replace);
        
        // If no onboarding redirect was needed, proceed with normal role-based routing
        if (!wasRedirected) {
          const userRole = getPrimaryRole(user);
          
          // Role-based redirection to admin dashboard
          if (userRole === 'student') {
            console.log('Student user - redirecting to admin dashboard');
            history.replace('/admin');
          } else if (userRole === 'client') {
            console.log('Client user - redirecting to admin dashboard');
            history.replace('/admin');
          } else if (['admin', 'superadmin', 'super_admin', 'manager'].includes(userRole)) {
            console.log('Admin/Superadmin user - redirecting to admin dashboard');
            history.replace('/admin');
          } else {
            console.log('Unknown role - defaulting to admin dashboard');
            history.replace('/admin');
          }
        }
      } else {
        // User is not authenticated, redirect to auth
        const clientLoginBaseUrl = sessionStorage.getItem('client_base_url');
        if (clientLoginBaseUrl) {
          window.location.href = clientLoginBaseUrl;
        } else {
          history.replace('/auth');
        }
      }
    }
  }, [isAuthenticated, isLoading, user, history]);

  // Show loading while checking authentication
  return (
    <div className="auth-loading">
      <Spin size="large" />
      <div className="auth-loading-text">
        Loading...
      </div>
    </div>
  );
};

export default LandingPage; 